import { createAction } from "@reduxjs/toolkit";

export const updateOrganizationData = createAction("UPDATE_ORGANIZATION_DATA");
export const resetOrganizationData = createAction("RESET_ORGANIZATION_DATA");
